import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useCompanySizeFilter } from './useCompanySizeFilter';

export const CompanySizeFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, companySizeOptions } = useCompanySizeFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ currentCompanySizes: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="currentCompanySizes"
          label="Current company size"
          placeholder="Add..."
          size="small"
          component={FormMultiSelect}
          options={companySizeOptions}
          anchorToBody
          isSearchable={false}
          dropdownFooter={
            <div style={{ padding: '8px 16px' }}>
              <p
                style={{ margin: '0', fontSize: '12px', lineHeight: '1.4', fontStyle: 'italic', color: 'text.subtle' }}
              >
                Not all companies are covered in our company size data.
              </p>
            </div>
          }
        />
      </Form>
    </Formik>
  );
};

CompanySizeFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

CompanySizeFilter.defaultProps = {
  value: [],
};
